<template lang="">
  <b-card>
    <validation-observer ref="cessionaria-modal" tag="div">
      <b-row>
        <b-col md="2">
          <b-form-group label="Quantidade de Parcelas" label-for="installmentsQuantity">
            <validation-provider #default="{ errors }" name="Quantidade de Parcelas" rules="required">
              <b-form-input
                id="installmentsQuantity"
                placeholder="Quantidade de Parcelas"
                v-model="data.installmentsQuantity"
                type="number"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <validation-provider #default="{ errors }" name="Produto" rules="required">
            <b-form-group label="Produto" label-for="productId">
              <v-select
                id="productId"
                v-model="data.productId"
                :options="optionsProduct"
                :reduce="(option) => option.value"
                label="text"
                @input="handleLoadRate"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col md="2">
          <b-form-group label="Taxa de Originação" label-for="originationRate">
            <validation-provider #default="{ errors }" name="Taxa de Originação" rules="required">
                <v-select
                  id="originationRate"
                  v-model="data.originationRate"
                  :options="optionsRate"
                  :reduce="(option) => option.value"
                   label="text"
                >
                <template #no-options>
          <div class="my-no-options-message">Selecione o Produto!</div>
        </template>
                <template slot="option" slot-scope="option">
          <div class="my-no-options-message">{{ option.text }}%</div>
        </template>
              </v-select>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Valor do contrato (Mín)" label-for="contractValueMin">
            <validation-provider #default="{ errors }" name="Valor do Contrato (Min)" rules="required">
              <b-input-group>
                <b-input-group-append>
                  <span class="input-group-text">R$</span>
                </b-input-group-append>
                <b-form-input
                  id="contractValueMin"
                  placeholder="Valor do Contrato (Min)"
                  v-model="data.contractValueMin"
                  v-number="number"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Valor do Contrato (Máx)" label-for="contractValueMax">
            <validation-provider #default="{ errors }" name="Valor do Contrato (Máx)" rules="required">
              <b-input-group>
                <b-input-group-append>
                  <span class="input-group-text">R$</span>
                </b-input-group-append>
                <b-form-input
                  id="contractValueMax"
                  placeholder="Valor do Contrato (Máx)"
                  v-model="data.contractValueMax"
                  v-number="number"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Taxa de Desconto" label-for="discountRate">
            <validation-provider #default="{ errors }" name="Taxa de Desconto" rules="required">
              <b-input-group>
                <b-input-group-append>
                  <span class="input-group-text">%</span>
                </b-input-group-append>
                <b-form-input id="discountRate" placeholder="Taxa de Desconto" v-model="data.discountRate" v-number="number" />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="2">
          <validation-provider #default="{ errors }" name="Unidade Gestora" rules="required">
            <b-form-group label="Unidade Gestora" label-for="instituteId">
              <v-select
                id="instituteId"
                v-model="data.instituteId"
                :options="optionsInstitute"
                :reduce="(option) => option.value"
                label="text"
                @input="handleLoadAgency"
              >
              <template #no-options>
          <div class="my-no-options-message">Nenhum registro encontrado!</div>
        </template></v-select>
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col md="2">
          <validation-provider #default="{ errors }" name="Órgão" rules="required">
            <b-form-group label="Órgão" label-for="agencyId">
              <v-select
                id="agencyId"
                v-model="data.agencyId"
                :options="optionsAgency"
                :reduce="(option) => option.value"
                label="text"
              >
              <template #no-options>
          <div class="my-no-options-message">Selecione a Unidade Gestora!</div>
        </template>
            </v-select>
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        
        <b-col>
          <div class="text-right mt-1">
            <b-button variant="primary" @click="handleSave" class="mr-1" style="width: 160px">
              {{ mode === 'edit' ? 'Editar' : 'Salvar' }}
            </b-button>
            <b-button variant="success" @click="handleClean()" style="width: 160px"> Limpar </b-button>
          </div>
        </b-col>
      </b-row>
    </validation-observer>

    <b-card-body v-if="items.length > 0">
      <b-table
        striped
        responsive
        id="table_cessionary_params"
        class="position-relative"
        :items="items"
        :fields="fields"
        v-show="items.length > 0"
        :per-page="table.perPage"
        :current-page="table.currentPage"
        :sort-by.sync="table.sortBy"
        :sort-desc.sync="table.sortDesc"
        :sort-direction="table.sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-1"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(opcoes)="row">
          <b-dropdown variant="link" no-caret toggle-class="p-0" left :popper-opts="{ positionFixed: true }">
            <template #button-content>
              <b-button variant="primary" class="btn-icon" title="Este botão contém as opções disponíveis para este registro">
                <feather-icon icon="SettingsIcon" />
              </b-button>
            </template>
            <b-dropdown-item @click="handleEdit(row.item)">
              <feather-icon icon="EditIcon" size="16" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item @click="handleDelete(row.item.id)">
              <feather-icon icon="XIcon" size="16" />
              <span class="align-middle ml-50">Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <b-card-body v-if="items.length > 0" class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          style="align-items: center"
          label="Por Página"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select id="perPageSelect" v-model="table.perPage" size="sm" inline :options="table.pageOptions" />
        </b-form-group>
        <b-pagination
          v-model="table.currentPage"
          :total-rows="items.length"
          :per-page="table.perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card-body>
    </b-card-body>
  </b-card>
</template>
<script>
  import { FormWizard } from 'vue-form-wizard'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import Cleave from 'vue-cleave-component'
  import { required } from '@validations'
  import useJwt from '@/auth/jwt/useJwt'
  import vSelect from 'vue-select'
  import { formatarParaNumber, formatarValor, formatarValorPorcentagem } from '@/libs/utils'

  export default {
    components: {
      FormWizard,
      ValidationProvider,
      ValidationObserver,
      Cleave,
      vSelect,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        required,
        cleave: {},
        number: {},
        mode: 'create',
        data: {
          installmentsQuantity: null,
          originationRate: null,
          contractValueMin: null,
          contractValueMax: null,
          discountRate: null,
          instituteId: null,
          agencyId: null,
          productId: null,
          cessionariaId: null,
        },

        table: {
          perPage: 10,
          currentPage: 1,
          pageOptions: [10, 50, 100],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
        },

        fields: [
          { key: 'opcoes', label: 'Opções' },
          { key: 'installmentsQuantity', label: 'Quantidade de parcelas', sortable: true, sortDirection: 'desc' },
          {
            key: 'originationRate',
            label: 'Taxa de originação',
            sortable: true,
            sortDirection: 'desc',
            formatter: (value) => {
              return formatarValorPorcentagem(value)
            },
          },
          {
            key: 'contractValueMin',
            label: 'Valor do contrato (mín)',
            sortable: true,
            sortDirection: 'desc',
            formatter: (value) => {
              return formatarValor(value)
            },
          },
          {
            key: 'contractValueMax',
            label: 'Valor do contrato (máx)',
            sortable: true,
            sortDirection: 'desc',
            formatter: (value) => {
              return formatarValor(value)
            },
          },
          {
            key: 'discountRate',
            label: 'Taxa de desconto',
            sortable: true,
            sortDirection: 'desc',
            formatter: (value) => {
              return formatarValorPorcentagem(value)
            },
          },
          { key: 'institute', label: 'Unidade Gestora', sortable: true, sortDirection: 'desc' },
          { key: 'agency', label: 'Órgão', sortable: true, sortDirection: 'desc' },
          { key: 'product', label: 'Produto', sortable: true, sortDirection: 'desc' },
        ],

        optionsInstitute: [],
        optionsAgency: [],
        optionsProduct: [],
        optionsRate: [],

        items: [],
      }
    },
    mounted() {
      this.handleLoadInstitute()
      this.handleLoadProduct()
      this.handleLoadParams()
      
    },

    methods: {
      buildPayload() {
        return {
          ...this.data,
          contractValueMin: formatarParaNumber(this.data.contractValueMin),
          contractValueMax: formatarParaNumber(this.data.contractValueMax),
          originationRate: formatarParaNumber(this.data.originationRate),
          discountRate: formatarParaNumber(this.data.discountRate),
          cessionariaId: this.item.id,
          id: this.data.id ?? null,
        }
      },
      handleSave() {
        this.$refs['cessionaria-modal'].validate().then((success) => {
          if (!success) return

          const payload = this.buildPayload()

          const request =
            this.mode === 'edit' ? useJwt.put(`cessionaria/params`, payload) : useJwt.post('cessionaria/params', payload)

          request
            .then(() => {
              const mensagem = this.mode === 'edit' ? 'Parâmetro editado com sucesso!' : 'Parâmetro cadastrado com sucesso!'

              this.$message.success(mensagem)
              this.handleLoadParams()
              this.handleClean()
            })
            .catch((error) => {
              if (error.response?.status === 409) {
                this.$message.error('Parâmetro já cadastrado para essa cessionária!')
              } else {
                this.$message.error('Erro ao salvar cessionária!')
              }
            })
            .finally(() => {
              this.mode = 'create'
            })
        })
      },
      handleEdit(item) {
        this.mode = 'edit'

        this.$refs['cessionaria-modal']?.reset()

        this.data = {
          id: item.id ?? null,
          installmentsQuantity: item.installmentsQuantity ?? null,
          contractValueMin: Number(item.contractValueMin).toFixed(2),
          contractValueMax: Number(item.contractValueMax).toFixed(2),
          originationRate: Number(item.originationRate).toFixed(2),
          discountRate: Number(item.discountRate).toFixed(2),
          instituteId: item.instituteId ?? null,
          agencyId: item.agencyId ?? null,
          productId: item.productId ?? null,
          cessionariaId: this.item.id,
        }

        if (this.data.instituteId) {
          this.handleLoadAgency()
        }
        if (this.data.productId) {
          this.handleLoadRate()
        }
      },

      handleDelete(id) {
        this.$swal({
          title: 'Atenção!',
          text: 'Deseja realmente excluir esse registro?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim!',
          cancelButtonText: 'Não!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value)
            useJwt
              .delete(`cessionaria/params`, id)
              .then(() => {
                this.$message.success('Parâmetro excluído com sucesso!')
                this.handleLoadParams()
              })
              .catch((error) => {
                this.$message.error('Erro ao excluir parâmetro!')
              })
        })
      },

      handleLoadParams() {
        useJwt.get(`cessionaria/${this.item.id}/params/batch`).then((response) => {
          this.items = response.data
        })
      },

      handleLoadInstitute() {
        useJwt
          .get('cadastro/instituto')
          .then((response) => {
            const list = response.data.map((item) => {
              return { value: item.id, text: String(item.nome) }
            })
            this.optionsInstitute = [...list]
          })
          .catch((error) => {
            console.error(error)
          })
      },

      handleLoadAgency() {
        useJwt
          .get('cadastro/orgao')
          .then((response) => {
            const list = response.data.filter((agencyId) => agencyId.institutoId == this.data.instituteId)
            const options = list.map((item) => {
              return { value: item.id, text: String(item.nome) }
            })
            this.optionsAgency = options
          })
          .catch((error) => {
            console.error(error)
          })
      },
      handleLoadProduct() {
        useJwt
          .post('produto/getAllProducts', {})
          .then((response) => {
            this.optionsProduct = response.data.map((item) => {
              return {
                value: item.id,
                text: item.nome,
              }
            })
          })
          .catch((error) => {
            console.error(error)
            this.$message.error('Erro ao carregar a lista de produtos!')
          })
      },

      handleLoadRate() {
        useJwt
          .get(`produto/getTaxas/${this.data.productId}`)
          .then((response) => {
            this.optionsRate = response.data.map((item) => {
              return {
                value: item.taxaMensal,
                text: item.taxaMensal,
              }
            })
            
            
          })
          .catch((error) => {
            console.error(error)
            this.$message.error('Erro ao carregar taxas!')
          })
      },

      handleClean() {
        this.data = {
          installmentsQuantity: null,
          originationRate: null,
          contractValueMin: null,
          contractValueMax: null,
          discountRate: null,
          instituteId: null,
          agencyId: null,
          productId: null,
        }
        this.$refs['cessionaria-modal']?.reset()
      },
    },
  }
</script>
<style>
  .input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text {
    border: 1px solid #ced4da;
    border-radius: 5px 0 0 5px;
  }
</style>
